import {createShopifyImageUrl} from '@/utilities/create-shopify-image-url';
import classNames from 'classnames';
import {forwardRef} from 'preact/compat';

/**
 * Renders a preview of an image in a carousel.
 * These are clickable and can be used to navigate to the corresponding slide.
 *
 * @param image - The image object to display.
 * @param isActive - Indicates whether the image is active.
 * @param onClick - The callback function to handle click events.
 * @returns  The rendered component.
 */
const CarouselImagePreviewSquare = forwardRef<
  HTMLButtonElement,
  CarouselImagePreviewSquareProps
>(function (
  {image, isActive = false, onClick}: CarouselImagePreviewSquareProps,
  ref
) {
  return (
    <button onClick={onClick} ref={ref}>
      <div
        key={image.url}
        className={classNames(
          'size-16 overflow-hidden rounded-lg transition-all duration-150 ease-in-out',
          {
            'border-2 border-breeze-blue': isActive,
          }
        )}
      >
        <img
          src={createShopifyImageUrl(image.url, 64)}
          alt={`${image.alt ?? ''} Thumbnail`}
          className="size-full object-cover"
        />
      </div>
    </button>
  );
});

export default CarouselImagePreviewSquare;

export type CarouselImagePreviewSquareProps = {
  image: Image;
  isActive: boolean;
  onClick?: () => void;
};

type Image = {
  alt: string | null;
  url: string;
};
